import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import SearchDropdown from "../../input/SearchDropdown";
import { getOtherRefSearchDropdown } from "../../../api/keyvalue";
import { formatFromJsonDate, isAfter } from "../../../dateConfig";
import { getBehalfOf } from "../../../api/systemUserApi";
import DateTimePickerInput from "../../input/DateTimePickerInput";
import { useDispatch, useSelector } from "react-redux";
import { requestActions } from "../../../store/request-slice";
import Dropdown from "../../input/Dropdown";
import Input from "../../input/Input";
import { validateRequestInitiation } from "../../validations/validateRequestCreation";
import { FORMS, MODULES } from "../../../const";
import { getContactByOpeAndRefAndType } from "../../../api/contactApi";
import { shipmentsByCustomer } from "../../../api/customerShipmentApi";
import { validateQuickRequestInitiation } from "../../validations/ValidateQuickRequestCreation";

const FORM = FORMS.QUICK_REQUEST.CREATION_INFO.form;

const QuickRequestInitiation = forwardRef(
  ({ dropdown, editMode, isLoading }, ref) => {
    const plantRef = useRef();
    const viewOnlyMode = useSelector((state) => state.request.viewOnlyMode);
    const userData = useSelector((state) => state.user.userDetails);
    const user = useSelector((state) => state.user);

    const userDetails = useSelector((state) => state.user.userDetails);
    const showBehalfOf = userDetails.type === 1;
    const currentValues = useSelector(
      (state) => state.request.currentValues.requestCreationInit,
    );
    const nextButtonErrors = useSelector(
      (state) => state.error.requestCreationErrors.requestErrors,
    );

    const errors = useSelector((state) => state.request.requestInitErrors);
    const [requestInitiation, setRequestInitiation] = useState({
      reqLCustomerId: null,
      reqBehalfOf: "",
      reqLPlantId: null,
      reqDepartment: null,
      reqBookingRequiredDate: "",
      reqBookingRequiredDateFormatted: "",
      reqContactPerson: "",
      reqContactNumber: "",
      reqContactEmail: "",
      reqShipmentType: 2,
      reqExportImport: 3,
      reqDeliveryCutoff: "",
      reqDeliveryCutoffFormatted: "",
      reqReferanceValue: "",
      reqInvoiceRef: "",
      reqVessel: "",
      reqVayage: "",
      reqConsolidateAllowed: 2,
      reqType: 1,
      reqPackages: null,
      reqPono: "",
      reqBlno: "",
      reqOperationType: "",
    });
    const [currentErrors, setCurrentErrors] = useState({});
    const [operationTypeOptions, setOperationTypeOptions] = useState([]);

    const customerId = useSelector((state) => state.request.reqLCustomerId);
    console.log("customerId", customerId);
    useEffect(() => {
      (async () => {
        if (customerId) {
          const data = await shipmentsByCustomer(customerId);
          setOperationTypeOptions(data);
        } else {
          setOperationTypeOptions([]);
        }
      })();
    }, [customerId]);

    useEffect(() => {
      (async () => {
        if (!editMode) {
          if (userDetails) {
            setRequestInitiation((prevState) => ({
              ...prevState,
              reqContactPerson: `${userDetails.firstName} ${userDetails.lastName}`,
              reqContactNumber: userDetails?.contactNo ?? "",
              reqContactEmail: userDetails?.email ?? "",
            }));
          }
        }
      })();
    }, [editMode, userDetails]);

    useEffect(() => {
      setCurrentErrors((prevState) => ({ ...prevState, ...nextButtonErrors }));
    }, [nextButtonErrors]);

    useEffect(() => {
      setCurrentErrors(errors);
    }, [errors]);

    useEffect(() => {
      if (editMode) {
        setRequestInitiation(currentValues);
      }
    }, [editMode, currentValues]);

    const dispatch = useDispatch();

    function validateEmail(email) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(email);
    }

    const [searchFieldReset, setSearchFieldReset] = useState(false);

    useImperativeHandle(ref, () => ({
      getData: () => requestInitiation,
      validateForm: () => {
        return validateQuickRequestInitiation(requestInitiation);
      },
    }));

    return (
      <div>
        <form className="ui form">
          <div className="ui segment">
            <div className="field">
              <div className="ui segment">
                <div className="field">
                  <h4 className="ui dividing header">Customer Details</h4>
                  <div className={showBehalfOf ? "two fields" : "field"}>
                    {userData.type === 1 ? (
                      <SearchDropdown
                        key={1}
                        readOnly={editMode}
                        editMode={editMode}
                        reset={searchFieldReset}
                        setReset={setSearchFieldReset}
                        value={requestInitiation?.reqLCustomerId}
                        clearable={true}
                        form={FORM}
                        module={MODULES.Transaction}
                        field="req_customer_id"
                        onClear={() => {
                          dispatch(
                            requestActions.setRequest({ reqLCustomerId: null }),
                          );
                          setRequestInitiation((prevState) => ({
                            ...prevState,
                            reqLPlantId: null,
                            reqLCustomerId: null,
                            reqContactPerson: "",
                            reqContactNumber: "",
                            reqContactEmail: "",
                          }));
                          plantRef?.current?.reset();
                        }}
                        onResultSelect={(data) => {
                          dispatch(
                            requestActions.setRequest({ reqLCustomerId: data }),
                          );
                          setRequestInitiation((prevState) => ({
                            ...prevState,
                            reqLCustomerId: data,
                            reqLPlantId: null,
                          }));
                          plantRef?.current?.reset();
                        }}
                        api={getOtherRefSearchDropdown}
                        checkCount={true}
                        apiDependency={{
                          type: "stakeholder_type",
                          value: "Customer",
                        }}
                        fieldInfo={{
                          tableName: "masterdata.tms_m_stakeholder",
                          primaryKey: "stk_id",
                          fieldName: "stk_name",
                          id: requestInitiation?.reqLCustomerId,
                        }}
                        required={true}
                        label="Customer"
                        error={currentErrors.reqLCustomerId}
                        resetError={() =>
                          setCurrentErrors((prevState) => {
                            const { reqLCustomerId: _, ...rest } = prevState;
                            return rest;
                          })
                        }
                      />
                    ) : (
                      <SearchDropdown
                        key={1}
                        readOnly={editMode}
                        editMode={editMode}
                        reset={searchFieldReset}
                        setReset={setSearchFieldReset}
                        value={requestInitiation?.reqLCustomerId}
                        clearable={true}
                        checkCount={true}
                        form={FORM}
                        module={MODULES.Transaction}
                        field="req_customer_id"
                        onClear={() => {
                          dispatch(
                            requestActions.setRequest({ reqLCustomerId: null }),
                          );
                          setRequestInitiation((prevState) => ({
                            ...prevState,
                            reqLPlantId: null,
                            reqLCustomerId: null,
                            reqContactPerson: "",
                            reqContactNumber: "",
                            reqContactEmail: "",
                          }));
                          plantRef?.current?.reset();
                        }}
                        onResultSelect={(data) => {
                          dispatch(
                            requestActions.setRequest({
                              reqLCustomerId: data,
                            }),
                          );
                          setRequestInitiation((prevState) => ({
                            ...prevState,
                            reqLCustomerId: data,
                            reqLPlantId: null,
                          }));
                          plantRef?.current?.reset();
                        }}
                        api={getOtherRefSearchDropdown}
                        apiDependency={{
                          type: "user_stakeholder",
                          value: "Requesting Customer",
                          param2: user.username,
                        }}
                        fieldInfo={{
                          tableName: "masterdata.tms_m_stakeholder",
                          primaryKey: "stk_id",
                          fieldName: "stk_name",
                          id: requestInitiation?.reqLCustomerId,
                        }}
                        required={true}
                        label="Customer"
                        error={currentErrors.reqLCustomerId}
                        resetError={() =>
                          setCurrentErrors((prevState) => {
                            const { reqLCustomerId: _, ...rest } = prevState;
                            return rest;
                          })
                        }
                      />
                    )}
                    {showBehalfOf && (
                      <SearchDropdown
                        key={1}
                        editMode={editMode}
                        readOnly={viewOnlyMode}
                        reset={searchFieldReset}
                        setReset={setSearchFieldReset}
                        value={requestInitiation?.reqBehalfOf}
                        clearable={true}
                        form={FORM}
                        module={MODULES.Transaction}
                        checkCount={true}
                        field="req_behalf_of"
                        returnFullObject={true}
                        onClear={() => {
                          setRequestInitiation((prevState) => ({
                            ...prevState,
                            reqBehalfOf: -1,
                            reqContactPerson: `${userDetails?.firstName} ${userDetails?.lastName}`,
                            reqContactNumber: userDetails?.contactNo ?? "",
                            reqContactEmail: userDetails?.email ?? "",
                          }));
                        }}
                        onResultSelect={(data) => {
                          setRequestInitiation((prevState) => ({
                            ...prevState,
                            reqBehalfOf: data.value,
                            reqContactPerson: `${data.usrFirstname} ${data.usrSecondName}`,
                            reqContactNumber: data.usrContact ?? "",
                            reqContactEmail: data.usrEmail ?? "",
                          }));
                        }}
                        api={getBehalfOf}
                        apiDependency={{
                          customer:
                            requestInitiation?.reqLCustomerId?.toString(),
                          shipper: requestInitiation?.reqLPlantId?.toString(),
                        }}
                        fieldInfo={{
                          tableName: "authentication.user",
                          primaryKey: "user_seq",
                          fieldName: "username",
                          id: requestInitiation?.reqBehalfOf,
                        }}
                        label="Behalf of"
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="ui segment">
                <div className="field">
                  <h4 className="ui dividing header">Request Details</h4>
                  <div className="two fields">
                    <SearchDropdown
                      readOnly={viewOnlyMode}
                      disabled={
                        requestInitiation?.reqLCustomerId === null ||
                        requestInitiation?.reqLCustomerId === ""
                      }
                      ref={plantRef}
                      key={1}
                      editMode={editMode}
                      reset={searchFieldReset}
                      setReset={setSearchFieldReset}
                      value={requestInitiation?.reqLPlantId}
                      clearable={true}
                      form={FORM}
                      module={MODULES.Transaction}
                      field="req_plant_id"
                      checkCount={true}
                      onClear={() => {
                        dispatch(
                          requestActions.setRequest({
                            reqLPlantId: null,
                          }),
                        );
                        setRequestInitiation((prevState) => ({
                          ...prevState,
                          reqLPlantId: null,
                        }));
                      }}
                      onResultSelect={(data) => {
                        dispatch(
                          requestActions.setRequest({
                            reqLPlantId: data,
                          }),
                        );
                        setRequestInitiation((prevState) => ({
                          ...prevState,
                          reqLPlantId: data,
                        }));
                      }}
                      api={getOtherRefSearchDropdown}
                      apiDependency={
                        userData.type === 1
                          ? {
                              type: "stakeholder_type",
                              value: "Shipper",
                              param2:
                                requestInitiation?.reqLCustomerId?.toString(),
                            }
                          : {
                              type: "user_stakeholder",
                              value: "Shipper",
                              param1:
                                requestInitiation?.reqLCustomerId?.toString(),
                              param2: user.username,
                            }
                      }
                      fieldInfo={{
                        tableName: "masterdata.tms_m_stakeholder",
                        primaryKey: "stk_id",
                        fieldName: "stk_name",
                        id: requestInitiation?.reqLPlantId,
                      }}
                      required={true}
                      label="Plant Name"
                      error={currentErrors.reqLPlantId}
                      resetError={() =>
                        setCurrentErrors((prevState) => {
                          const { reqLPlantId: _, ...rest } = prevState;
                          return rest;
                        })
                      }
                    />
                    <Input
                      readOnly={viewOnlyMode}
                      required={true}
                      label="Contact Person"
                      error={currentErrors.reqContactPerson}
                      form={FORM}
                      module={MODULES.Transaction}
                      field="req_contact_person"
                      resetError={() =>
                        setCurrentErrors((prevState) => {
                          const { reqContactPerson: _, ...rest } = prevState;
                          return rest;
                        })
                      }
                      name="contact_person"
                      value={requestInitiation?.reqContactPerson}
                      onChange={(e) => {
                        setRequestInitiation((prevState) => ({
                          ...prevState,
                          reqContactPerson: e.target.value,
                        }));
                      }}
                    />
                    <Input
                      readOnly={viewOnlyMode}
                      required={true}
                      label="Contact Number"
                      error={currentErrors.reqContactNumber}
                      form={FORM}
                      module={MODULES.Transaction}
                      field="req_contact_number"
                      resetError={() =>
                        setCurrentErrors((prevState) => {
                          const { reqContactNumber: _, ...rest } = prevState;
                          return rest;
                        })
                      }
                      type="tel"
                      name="contact_number"
                      pattern="(^[0-9]{10}$)"
                      value={requestInitiation?.reqContactNumber}
                      onChange={(e) =>
                        setRequestInitiation((prevState) => ({
                          ...prevState,
                          reqContactNumber: e.target.value,
                        }))
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="ui segment">
                <div className="field">
                  <h4 className="ui dividing header">Shipment Details</h4>
                  <div className="two fields">
                    <Dropdown
                      readOnly={viewOnlyMode}
                      label="Operation Type"
                      error={errors.reqOperationType}
                      form={FORM}
                      module={MODULES.Transaction}
                      field="req_operation_type "
                      resetError={() =>
                        setCurrentErrors((prevState) => {
                          const { reqOperationType: _, ...rest } = prevState;
                          return rest;
                        })
                      }
                      name="operation_type"
                      style={{ height: "20px" }}
                      options={operationTypeOptions}
                      value={requestInitiation?.reqOperationType}
                      onChange={(e, data) =>
                        setRequestInitiation((prevState) => ({
                          ...prevState,
                          reqOperationType: data.value,
                        }))
                      }
                    />
                    {/* <Dropdown
                    required={true}
                    readOnly={viewOnlyMode}
                    label="Shipment Type"
                    error={currentErrors.reqShipmentType}
                    form={FORM}
                    module={MODULES.Transaction}
                    field="req_shipment_type"
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { reqShipmentType: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    placeholder="Shipment Type"
                    options={dropdown.shipmentTypeOptions}
                    value={requestInitiation?.reqShipmentType}
                    style={{
                      height: "20px",
                    }}
                    onChange={(e, data) => {
                      setRequestInitiation((prevState) => ({
                        ...prevState,
                        reqShipmentType: data.value,
                      }));
                    }}
                  /> */}

                    <Input
                      readOnly={viewOnlyMode}
                      label="Packages"
                      error={currentErrors.reqPackages}
                      form={FORM}
                      module={MODULES.Transaction}
                      field="req_packages"
                      resetError={() =>
                        setCurrentErrors((prevState) => {
                          const { reqPackages: _, ...rest } = prevState;
                          return rest;
                        })
                      }
                      type="number"
                      min={0}
                      placeholder="Packages"
                      value={requestInitiation?.reqPackages}
                      onChange={(e) =>
                        setRequestInitiation((prevState) => ({
                          ...prevState,
                          reqPackages: e.target.value,
                        }))
                      }
                    />

                    <DateTimePickerInput
                      readOnly={viewOnlyMode}
                      reset={searchFieldReset}
                      form={FORM}
                      module={MODULES.Transaction}
                      field="req_delivery_cutoff"
                      setReset={setSearchFieldReset}
                      value={requestInitiation?.reqDeliveryCutoff}
                      style={{
                        borderColor: currentErrors.departureTime ? "red" : "",
                      }}
                      onAccept={(value) => {
                        setRequestInitiation((prevState) => ({
                          ...prevState,
                          reqDeliveryCutoff: value,
                          reqDeliveryCutoffFormatted: formatFromJsonDate(value),
                        }));
                      }}
                      validators={[
                        {
                          func: (date) => isAfter(date, new Date()),
                          message:
                            "Date and Time should be after current date and time",
                        },
                      ]}
                      error={currentErrors.reqDeliveryCutoff}
                      resetError={() =>
                        setCurrentErrors((prevState) => {
                          const { reqDeliveryCutoff: _, ...rest } = prevState;
                          return rest;
                        })
                      }
                      label="Cut off Time"
                    />
                  </div>
                  <div className="two fields">
                    <Input
                      readOnly={viewOnlyMode}
                      label="P.O No"
                      error={currentErrors.reqPono}
                      form={FORM}
                      module={MODULES.Transaction}
                      field="req_pono"
                      resetError={() =>
                        setCurrentErrors((prevState) => {
                          const { reqPono: _, ...rest } = prevState;
                          return rest;
                        })
                      }
                      placeholder="P.O No"
                      value={requestInitiation?.reqPono}
                      onChange={(e) =>
                        setRequestInitiation((prevState) => ({
                          ...prevState,
                          reqPono: e.target.value,
                        }))
                      }
                    />
                    <Input
                      readOnly={viewOnlyMode}
                      label="Invoice Ref No"
                      error={currentErrors.reqInvoiceRef}
                      form={FORM}
                      module={MODULES.Transaction}
                      field="req_invoice_ref"
                      resetError={() =>
                        setCurrentErrors((prevState) => {
                          const { reqInvoiceRef: _, ...rest } = prevState;
                          return rest;
                        })
                      }
                      name="inv_ref"
                      value={requestInitiation?.reqInvoiceRef}
                      onChange={(e) =>
                        setRequestInitiation((prevState) => ({
                          ...prevState,
                          reqInvoiceRef: e.target.value,
                        }))
                      }
                    />
                    <Input
                      readOnly={viewOnlyMode}
                      label="Vessel Number"
                      error={currentErrors.reqVessel}
                      form={FORM}
                      module={MODULES.Transaction}
                      field="req_vessel"
                      resetError={() =>
                        setCurrentErrors((prevState) => {
                          const { reqVessel: _, ...rest } = prevState;
                          return rest;
                        })
                      }
                      name="vessel_number"
                      value={requestInitiation?.reqVessel}
                      onChange={(e) =>
                        setRequestInitiation((prevState) => ({
                          ...prevState,
                          reqVessel: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="three fields">
                    <Input
                      readOnly={viewOnlyMode}
                      label="Voyage Number"
                      error={currentErrors.reqVayage}
                      form={FORM}
                      module={MODULES.Transaction}
                      field="req_vayage"
                      resetError={() =>
                        setCurrentErrors((prevState) => {
                          const { reqVayage: _, ...rest } = prevState;
                          return rest;
                        })
                      }
                      name="voy_number"
                      value={requestInitiation?.reqVayage}
                      onChange={(e) =>
                        setRequestInitiation((prevState) => ({
                          ...prevState,
                          reqVayage: e.target.value,
                        }))
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  },
);

export default QuickRequestInitiation;
